import { dlPushEvent } from "@/analytics/gtm";
import { Button } from "@/components/ui/button";
import ImageSvg from "@/components/ui/image-svg";
import { ArrowRight } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

interface TokenErrorProps {
  errorType: "missing" | "invalid" | "expired";
}

export default function TokenError({ errorType }: TokenErrorProps) {
  const getErrorMessage = () => {
    switch (errorType) {
      case "missing":
        return {
          title: "Link de acesso incompleto",
          description:
            "O link que você está tentando acessar está incompleto ou não possui as informações necessárias.",
        };
      case "invalid":
        return {
          title: "Link de acesso inválido",
          description:
            "O link que você está tentando acessar é inválido ou foi corrompido.",
        };
      case "expired":
        return {
          title: "Link de acesso expirado",
          description:
            "O link que você está tentando acessar expirou ou não é mais válido.",
        };
      default:
        return {
          title: "Problema de acesso à cotação",
          description: "Não foi possível acessar sua cotação.",
        };
    }
  };

  const { title, description } = getErrorMessage();

  useEffect(() => {
    dlPushEvent("cotacao_error", { error_type: `token_${errorType}` });
  }, [errorType]);

  return (
    <div className="flex flex-col max-w-6xl container max md:flex-row items-center justify-between gap-12 min-h-[80vh] px-6 py-10">
      
      <div className="max-w-lg text-left">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-n-primary mb-4">
          {title}
        </h2>

        <p className="text-n-primary mb-4">{description}</p>

        <p className="text-n-primary mb-10">
          Recomendamos fazer uma nova cotação:
        </p>

        <Link to="/fazer-cotacao">
          <Button className="">
            Fazer nova cotação
            <ArrowRight className="ml-2 " />
          </Button>
        </Link>

        <div className="mt-8 text-sm">
          <p className="font-semibold">Dúvidas quanto ao seu pedido?</p>
          <p className="text-n-text-neutral">
            Ligue para <span className="font-bold">0800 878 0708</span>
          </p>
        </div>
      </div>

      <div className="w-full max-w-md">
        <ImageSvg
          src="/mulher-celular.svg"
          alt="Erro de acesso"
          className="w-full h-auto"
        />
      </div>
    </div>
  );
}
